import React from 'react';
import { PrinterIcon, ScissorsIcon, HeartHandshakeIcon } from 'lucide-react';
type PrintCutShareProps = {
  align?: 'center' | 'start';
};
const items = [{
  label: 'Ausdrucken',
  Icon: PrinterIcon
}, {
  label: 'Ausschneiden',
  Icon: ScissorsIcon
}, {
  label: 'Weitergeben',
  Icon: HeartHandshakeIcon
}];
export function PrintCutShare({
  align = 'center'
}: PrintCutShareProps) {
  return <p className={`flex flex-wrap items-center gap-x-1.5 gap-y-2 text-navy sm:gap-x-3 ${align === 'center' ? 'justify-center' : 'justify-center lg:justify-start'}`} aria-label="Ausdrucken, ausschneiden, weitergeben" data-id="element-223" data-mp="2060977n0mmfw">
      {items.map(({
      label,
      Icon
    }, i) => <React.Fragment key={label} data-id="element-224" data-mp="1lgkly1mp0z4y" data-mpi={i}>
          {i > 0 && <span className="text-gold" aria-hidden="true" data-id="element-225" data-mp="1lft0hjmt8hse">•</span>}
          <span className="inline-flex items-center gap-1 whitespace-nowrap text-[10.5px] font-extrabold uppercase tracking-[0.02em] sm:gap-1.5 sm:text-base sm:tracking-[0.12em]" data-id="element-226" data-mp="2ivos22dlecew">
            <Icon className="hidden h-4 w-4 text-coral min-[400px]:block sm:h-5 sm:w-5" aria-hidden="true" data-id="element-227" data-mp="2sjpdumew8s1u" />
            {label}
          </span>
        </React.Fragment>)}
    </p>;
}